
  <div class="fullPage">
    <div class="mainContent">
        <div class="Header">
            <div style="text-align:left;"><img src="../assets/images/LogoTop.gif" /></div>
        </div>
        <div class="MenuHolder">
            <div class="Menu" id="NavigationMenu" style="float: left;">
                <ul class="level1 static" tabindex="0" role="menubar" style="position: relative; width: auto; float: left;">
                    <li role="menuitem" class="static" style="position: relative; float: left;"><a class="level1 static" routerLink="/Home"  tabindex="-1">home</a></li>
                    <li role="menuitem" class="static" style="position: relative; float: left;"><a class="level1 static" routerLink="/About" tabindex="-1">about</a></li>
                    <li role="menuitem" class="static" style="position: relative; float: left;"><a class="level1 static" routerLink="/Residential" tabindex="-1">residential</a></li>
                    <li role="menuitem" class="static" style="position: relative; float: left;"><a class="level1 static" routerLink="/Commercial"  tabindex="-1">commercial</a></li>
                    <li role="menuitem" class="static" style="position: relative; float: left;"><a class="level1 static" routerLink="/Campus"  tabindex="-1">campus development</a></li>
                    <li role="menuitem" class="static" style="position: relative; float: left;"><a class="level1 static" routerLink="/EHouse" tabindex="-1">salt e-house pty ltd</a></li>
                </ul>
            </div>
            <div style="clear: left;"></div>
            <a id="NavigationMenu_SkipLink"></a>
        </div>
        <div id="LabelError" class="ErrorBox" style="display:none;"></div>
        <div class="innerContent">      
            <router-outlet></router-outlet>        
        </div>
        <div style="width:100%; height:3px; background-color:#d86100;line-height:3px;margin-top:5px;"></div>
        <div class="Footer">
        
                <div style="font-size:18px; color:#999999; text-align:center;"><br />
                    <span class="Highlight">S</span>USTAINABLE <span class="Highlight">A</span>RCHITECTURE 
                    <span class="Highlight">L</span>IFE <span class="Highlight">T</span>ECHNOLOGIES<br />

                </div>

                716 Anzac Highway Glenelg SA 5045 &nbsp;&nbsp;&nbsp; Phone & Fax: 08 82958854 &nbsp;&nbsp;&nbsp;  Email: <a href="mailto:Salt@SaltStudio.net.au">Salt@SaltStudio.net.au</a>
            

        <br />
        <a href="SiteMap.ascx">site map</a> | <a href="http://www.facebook.com/pages/Salt-Studio-Architecture/87250512108"  target="_blank" >facebook page </a>  | <a href="http://www.saltehouse.com.au" target="_blank">Salt E-House PTY LTD</a> 
        </div> 
    </div>
</div>
<br /><br /><br /><br />
<br /><br /><br /><br />
<br /><br /><br /><br />


